import { PageHeader } from '../components/ui/PageHeader.tsx';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.ts';
import { useGridQuery, useGridState } from '../lib/grid.ts';
import { DataTable, type Column } from '../components/DataTable.tsx';
import { fmtDateTime } from '../lib/date.ts';

interface AuditRow { seq: string; occurredAt: string; actorType: string; actorId: string | null; actorName: string; action: string; targetType: string | null; targetId: string | null; ip: string | null; hash: string | null }
const ACTOR: Record<string, string> = { user: '사용자', vendor_user: '수탁사', system: '시스템' };

const columns: Column<AuditRow>[] = [
  { key: 'seq', label: 'seq', width: '5rem', align: 'right', filter: 'none' },
  { key: 'occurredAt', label: '시각', width: '11rem', filter: 'date', render: (r) => <span className="whitespace-nowrap">{fmtDateTime(r.occurredAt)}</span> },
  { key: 'actorType', label: '행위자 유형', width: '7rem', filter: 'select', render: (r) => ACTOR[r.actorType] ?? r.actorType },
  { key: 'actorId', label: '행위자', width: '9rem', sortable: false, render: (r) => r.actorName || (r.actorId?.slice(0, 8) ?? '—') },
  { key: 'action', label: '행위', width: '12rem', filter: 'select' },
  { key: 'targetType', label: '대상 유형', width: '8rem', filter: 'text' },
  { key: 'targetId', label: '대상', row: 2, span: 3, filter: 'text', render: (r) => r.targetId?.slice(0, 8) },
  { key: 'ip', label: 'IP', width: '8rem', filter: 'text' },
  { key: 'hash', label: 'hash', row: 2, span: 4, sortable: false, render: (r) => <span className="font-mono text-[11px]">{r.hash?.slice(0, 16)}…</span> },
];

/** 접속기록 — 서버사이드 그리드 */
export function AuditLogPage() {
  const { state, set } = useGridState('a', { sort: { col: 'seq', dir: 'desc' } });
  const logs = useGridQuery<AuditRow>('audit-grid', '/audit/grid', state);
  const verify = useQuery({ queryKey: ['audit-verify'], queryFn: () => api<{ ok: boolean; brokenAtSeq: string | null }>('/audit/verify') });
  return (
    <div>
      <PageHeader title="접속기록" />
      <div className="mb-3 text-sm">
        해시 체인 검증:{' '}
        {verify.data ? (verify.data.ok ? <span className="text-green-700 font-medium">정상</span> : <span className="text-red-700 font-medium">seq {verify.data.brokenAtSeq} 에서 불일치</span>) : '…'}
      </div>
      {logs.isError && <div className="text-red-600 text-sm mb-2">{(logs.error as Error).message}</div>}
      <DataTable id="audit-log" columns={columns} data={logs.data} state={state} onChange={set} rowKey={(r) => r.seq} isFetching={logs.isFetching} />
    </div>
  );
}
